import { createSlice } from '@reduxjs/toolkit';

const initialDetailData = {
  rjoLog: [],
  ttLog: [],
  ebtke: [],
  depnaker: [],
  migas: [],
};

const initialDetailTabLabels = {
  rjo: 'RJO',
  tt: 'Trouble Ticket',
  migas: 'Migas',
  depnaker: 'Depnaker',
  ebtke: 'EBTKE',
  record: 'Record',
};

const normalizeDetailData = (payload, fallback = initialDetailData) => {
  const detail = payload?.Detail || payload?.detail || payload?.detailData;
  if (!detail || typeof detail !== 'object') {
    return fallback;
  }

  return {
    rjoLog: Array.isArray(detail.RJO_log) ? detail.RJO_log : Array.isArray(detail.rjoLog) ? detail.rjoLog : [],
    ttLog: Array.isArray(detail.TT_log) ? detail.TT_log : Array.isArray(detail.ttLog) ? detail.ttLog : [],
    ebtke: Array.isArray(detail.ebtke) ? detail.ebtke : [],
    depnaker: Array.isArray(detail.depnaker) ? detail.depnaker : [],
    migas: Array.isArray(detail.migas) ? detail.migas : [],
  };
};

const normalizeDetailTabLabels = (payload, fallback = initialDetailTabLabels) => {
  const tabs = payload?.Tabs || payload?.tabs;
  if (!tabs || typeof tabs !== 'object') {
    return fallback;
  }

  return {
    rjo: tabs.rjo_log || fallback.rjo,
    tt: tabs.tt_log || fallback.tt,
    migas: fallback.migas,
    depnaker: fallback.depnaker,
    ebtke: fallback.ebtke,
    record: fallback.record,
  };
};

const normalizeHeaderData = (payload) => {
  if (payload?.Header && typeof payload.Header === 'object') {
    return payload.Header;
  }
  if (payload?.formData && typeof payload.formData === 'object') {
    return payload.formData;
  }
  return payload || {};
};

const initialState = {
  selectedRow: null,
  formData: {
    equip_id: '',
    equip_oldid: '',
    equip_name: '',
    brand_id: '',
    model_id: '',
    cranetype_id: '',
    equip_sn: '',
    equip_chasis: '',
    equip_enginedown: '',
    equip_engineup: '',
    equip_capacity: '',
    equip_no: '',
    equip_yearmade: '',
    equip_firstbuy: '',
    equip_tyrerear: '',
    equip_tyrefront: '',
    equip_mainhoist: '',
    equip_boomhoist: '',
    equip_auxhoist: '',
    equip_hookblock: '',
    equip_ballhook: '',
    equip_fueltank: '',
    equip_hidrolik: '',
    equip_mainboom: '',
    equip_jip: '',
    equip_luffing: '',
    equip_createdby: '',
    equip_createdate: '',
    equip_modifyby: '',
    equip_modifydate: '',
    equip_status: '',
    equip_filename: '',
    location_id: '',
    equip_hm: 0,
    equip_km: 0,
    rowid: '',
    province_id: '',
    regency_id: '',
    district_id: '',
    village_id: '',
    equip_fulladdress: '',
    equip_divisi: 'PROJECT',
    category_id: '',
    equip_karoseri: '',
  },
  dataList: [],
  totalData: 0,
  detailData: initialDetailData,
  detailTabLabels: initialDetailTabLabels,
  loading: false,
  error: null,
  loadingMessage: '',
  activeTab: 0,
};

const mst07equipSlice = createSlice({
  name: 'mst07equip',
  initialState,
  reducers: {
    setSelectedRow: (state, action) => {
      state.selectedRow = action.payload;
    },
    setFormData: (state, action) => {
      state.formData = action.payload;
    },
    clearFormData: (state) => {
      state.formData = initialState.formData;
      state.detailData = initialDetailData;
      state.detailTabLabels = initialDetailTabLabels;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setErrorMsg: (state, action) => {
      state.error = action.payload;
    },
    setLoadingMessage: (state, action) => {
      state.loadingMessage = action.payload;
    },
    fetchDetailSuccess: (state, action) => {
      const payload = action.payload || {};
      state.formData = { ...initialState.formData, ...normalizeHeaderData(payload) };
      state.detailData = normalizeDetailData(payload, state.detailData);
      state.detailTabLabels = normalizeDetailTabLabels(payload, state.detailTabLabels);
      state.loading = false;
      state.error = null;
    },
    fetchDetailFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchDetailError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    updateFormData: (state, action) => {
      state.loading = false;
      state.formData = { ...state.formData, ...action.payload };
    },
    resetState: () => initialState,
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
    setDataList: (state, action) => {
      state.dataList = action.payload;
    },
    setTotalData: (state, action) => {
      state.totalData = action.payload;
    },
    clearModuleState: (state) => {
      state.activeTab = 0;
      state.dataList = [];
      state.totalData = 0;
      state.loading = false;
      state.loadingMessage = '';
      state.error = null;
      state.selectedRow = null;
      state.formData = initialState.formData;
      state.detailData = initialDetailData;
      state.detailTabLabels = initialDetailTabLabels;
    },
  },
});

export const {
  setSelectedRow,
  setFormData,
  clearFormData,
  setLoading,
  setErrorMsg,
  setLoadingMessage,
  fetchDetailSuccess,
  fetchDetailFailure,
  fetchDetailError,
  resetState,
  updateFormData,
  setActiveTab,
  setDataList,
  setTotalData,
  clearModuleState,
} = mst07equipSlice.actions;

export default mst07equipSlice.reducer;
